/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { hourlyMetricsType } from '../../domain/DashboardData';
import WeekendMetricPrintingElement from './WeekendMetricPrintingElement';
import HourlyMetricPrintingElement from './HourlyMetricPrintingElement';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 275px;
`;

const HourlyMetricWrapper = styled.div`
  width: 80%
`;

const WeekendMetricWrapper = styled.div`
  width: 20%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
`;

type Props = {
  data: Object,
  t: any,
  type: hourlyMetricsType,
};

function WeekMetricPrintingElement({ data, type, t }: Props) {
  const sundayMetric = type === 'reach' ? data.sundayComparedReach : data.sundayComparedListeningTime;
  const saturdayMetric = type === 'reach' ? data.saturdayComparedReach : data.saturdayComparedListeningTime;

  return (
    <Container>
      <HourlyMetricWrapper>
        <HourlyMetricPrintingElement
          metricType={type}
          typeText={t(type)}
          title={t('week')}
          data={data}
        />
      </HourlyMetricWrapper>
      <WeekendMetricWrapper>
        <WeekendMetricPrintingElement
          sundayMetric={sundayMetric}
          saturdayMetric={saturdayMetric}
        />
      </WeekendMetricWrapper>
    </Container>
  );
}

export default translate()(WeekMetricPrintingElement);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/components/WeekMetricPrintingElement.js